import type { Testimonial } from "../types/content";

export const testimonials: Testimonial[] = [
  {
    quote:
      "Remplacement de notre vieille chaudière fioul par une pompe à chaleur. Hydréa s'est occupé de tout, y compris du dossier MaPrimeRénov'. Notre facture a baissé de moitié dès le premier hiver.",
    name: "Claire & Julien M.",
    context: "Pompe à chaleur · Villeurbanne",
  },
  {
    quote:
      "Fuite un dimanche soir, technicien chez nous en 1 h 30. Efficace et tarif annoncé respecté.",
    name: "Karim B.",
    context: "Dépannage · Lyon 7e",
  },
  {
    quote:
      "Salle de bain entièrement refaite en trois semaines, chantier propre chaque soir. Le résultat est superbe.",
    name: "Hélène D.",
    context: "Salle de bain · Caluire",
  },
];
